import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSelectConditionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSelectConditionsQuery = { __typename?: 'Query', getConditions: Array<{ __typename?: 'Condition', id: string, name?: string | null }> };


export const GetSelectConditionsDocument = gql`
    query getSelectConditions {
  getConditions {
    id
    name
  }
}
    `;

/**
 * __useGetSelectConditionsQuery__
 *
 * To run a query within a React component, call `useGetSelectConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectConditionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelectConditionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSelectConditionsQuery, GetSelectConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectConditionsQuery, GetSelectConditionsQueryVariables>(GetSelectConditionsDocument, options);
      }
export function useGetSelectConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectConditionsQuery, GetSelectConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectConditionsQuery, GetSelectConditionsQueryVariables>(GetSelectConditionsDocument, options);
        }
export type GetSelectConditionsQueryHookResult = ReturnType<typeof useGetSelectConditionsQuery>;
export type GetSelectConditionsLazyQueryHookResult = ReturnType<typeof useGetSelectConditionsLazyQuery>;
export type GetSelectConditionsQueryResult = Apollo.QueryResult<GetSelectConditionsQuery, GetSelectConditionsQueryVariables>;